import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './grid.css';

const ReactTableGT2A = ({ page, onPageChange, showPaginationBottom, ...props }) => {
  const showFilters = typeof props.showFilters === 'boolean' ? props.showFilters : true;
  const pageSize = props.defaultPageSize || props.pageSize || 10;
  const dataLength = Array.isArray(props.data) ? props.data.length : 0;
  const totalPages =
    props.pages !== undefined && props.pages !== null
      ? Math.max(1, props.pages)
      : Math.max(1, Math.ceil(dataLength / pageSize));

  const shouldShowPagination =
    typeof showPaginationBottom === 'boolean' ? showPaginationBottom : totalPages > 1;

  return (
    <ReactTable
      {...props}
      page={page}
      onPageChange={onPageChange}
      loading={props.loading || false}
      loadingText="Carregando..."
      showPageSizeOptions={false}
      showPageJump={false}
      resizable={false}
      showFilters={showFilters}
      showPaginationBottom={shouldShowPagination}
      previousText={
        <div>
          <i className="fa fa-reply" /> <span>Anterior</span>
        </div>
      }
      nextText={
        <div>
          <i className="fa fa-share" /> <span>Próximo</span>
        </div>
      }
      noDataText="Nenhum registro encontrado"
      pageText="Página"
      ofText="de"
      rowsText="linhas"
    />
  );
};

export default ReactTableGT2A;
